var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeechbubble = function SvgSpeechbubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 2.25a9.75 9.75 0 00-8.608 14.332l-1.064 3.193a1.5 1.5 0 001.897 1.897l3.192-1.064A9.75 9.75 0 1012 2.25zm0 18a8.237 8.237 0 01-4.13-1.107.75.75 0 00-.614-.063L3.75 20.25l1.169-3.506a.75.75 0 00-.062-.613A8.25 8.25 0 1112 20.25z"
  })));
};
export default SvgSpeechbubble;